exports.components = {
  "component---src-templates-template-article-tsx": () => import("./../../../src/templates/templateArticle.tsx" /* webpackChunkName: "component---src-templates-template-article-tsx" */),
  "component---src-templates-template-articles-tsx": () => import("./../../../src/templates/templateArticles.tsx" /* webpackChunkName: "component---src-templates-template-articles-tsx" */),
  "component---src-templates-template-page-tsx": () => import("./../../../src/templates/templatePage.tsx" /* webpackChunkName: "component---src-templates-template-page-tsx" */)
}

